/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * With support for additional (shared/delegate) mailboxes as accounts userIdentity can no longer be counted on to uniquely identify an account. Replace userIdentity usage with AccountKey usage.
 *	> 'owa-account-source-list/lib/utils/getSourceIdForUserIdentity' import is restricted from being used. UserIdentity does not uniquely identify a mailbox. Use getCoprincipalAccountForAccountKey instead. */
import getSourceIdForUserIdentity from 'owa-account-source-list/lib/utils/getSourceIdForUserIdentity';
import { updateConnectedAccountState as updateConnectedAccountStateInStore } from 'owa-account-source-list-store';
import { logStartUsage } from 'owa-analytics-start';

// Updates the account associated with the specified user identity
export function updateConnectedAccountState(userIdentity: string, accountState: number): void {
    const sourceId = getSourceIdForUserIdentity(userIdentity);
    const sourceIdFound = !!sourceId;
    const accountFound = false;
    if (sourceId) {
        updateConnectedAccountStateInStore(sourceId, accountState);
    }
    /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
     * BASELINE: DO NOT COPY/PASTE!
     * undefined
     *	> Argument at index 1 for logStartUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
     (https://aka.ms/OWALintWiki)
         * Baseline. Dev touching this file must update to pass the active MailboxInfo; Docs: https://aka.ms/owa-analytics-mailboxinfo
         * undefined
         *	> MailboxInfo must be passed into the function to identify the account.
         (https://aka.ms/OWALintWiki)
             * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
             *	> Invalid Outlook telemetry EventName "updateConnectedAccountStateForAccountSourceList": must start with a capital letter (A–Z). */
    logStartUsage('updateConnectedAccountStateForAccountSourceList', undefined, {
        sourceIdFound,
        accountFound,
    });
}
